import { Provider } from "@angular/core";
import { ClientesUtils } from "./Clientes.utils";
import { ClientesUtilsImpl } from "./implementaciones/ClientesImpl.utils";
import { CuestionariosUtils } from "./Cuestionarios.utils";
import { CuestionariosUtilsImpl } from "./implementaciones/Cuestionarios.utils";
import { InvestigacionesUtils } from "./Investigaciones.utils";
import { InvestigacionesUtilsImpl } from "./implementaciones/InvestigacionesImpl.utils";

export const providersUtils: Provider[] = [
    { provide: ClientesUtils, useClass: ClientesUtilsImpl },
    { provide: CuestionariosUtils, useClass: CuestionariosUtilsImpl },
    { provide: InvestigacionesUtils, useClass: InvestigacionesUtilsImpl }
];
